import { render } from "./CvParser.vue?vue&type=template&id=44939795&scoped=true"
import script from "./CvParser.vue?vue&type=script&lang=js"
export * from "./CvParser.vue?vue&type=script&lang=js"

import "./CvParser.vue?vue&type=style&index=0&id=44939795&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44939795"]])

export default __exports__